export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 mx-6 mt-20 mb-6 rounded-[28px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20deep%20teal%20green%20gradient%20texture%20with%20soft%20organic%20flowing%20shapes%20subtle%20material%20depth%20minimal%20architectural%20composition%20dark%20moody%20atmospheric%20no%20people%20no%20text%20no%20interfaces%20smooth%20layered%20gradients%20elegant%20modern%20aesthetic&width=1600&height=900&seq=hero-bg-vasoft-01&orientation=landscape"
          alt="Abstract architectural gradients representing modern software engineering depth"
          title="VA Soft Labs LLC - Modern Engineering"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col items-center text-center px-6 pt-20">
        <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-white/30 mb-8">
          <span className="text-[11px] uppercase tracking-[0.2em] text-white/90 font-label font-medium">
            iOS Engineering
          </span>
        </div>

        <h2 className="text-5xl md:text-7xl font-heading font-semibold text-white leading-[1.1] tracking-tight max-w-4xl">
          Modern Digital Solutions
          <br />
          for the iOS Platform
        </h2>

        <p className="mt-7 text-base md:text-lg font-body font-light text-white/80 max-w-xl leading-relaxed">
          Scalable, maintainable, and high-performance systems engineered with a strong focus on usability, stability, and long-term technical quality.
        </p>
      </div>
    </section>
  );
}